const currencyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  signDisplay: 'auto',
});

const decimalFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  signDisplay: 'auto',
});

export const parsePrice = (value, toFixed = 2) => {
  if (!value) return 0;

  if (typeof value === 'number' && !isNaN(value)) {
    return Number(value.toFixed(toFixed));
  }

  const stringValue = String(value);

  if (stringValue.includes('.') && !stringValue.includes(',')) {
    return Number(parseFloat(stringValue).toFixed(toFixed));
  }

  return Number(
    parseFloat(stringValue.replace(/\s/g, '').replace('R$', '').replace(/\./g, '').replace(',', '.')).toFixed(toFixed)
  );
};

export const parseCommaToDot = (value) => {
  if (value === null || value === undefined || value === '') return 0;

  return parseFloat(String(value).replace(',', '.'));
};

export const formatWeight = (value) => {
  if (value == null || value === '') return '0.000';

  const clean = String(value).replace(/\s/g, '').replace('R$', '').replace(/\./g, '').replace(',', '.');

  const num = parseFloat(clean);
  if (isNaN(num)) return '0.000';

  const moved = num / 1000;

  return moved.toFixed(3);
};

export const formatPrice = (value, parse = true) => currencyFormatter.format(parse ? parsePrice(value) : value);

export const formatDecimal = (value) => decimalFormatter.format(value || 0);
